__turbopack_context__.v({
  "list": "List-module__KsnsyW__list",
  "ol": "List-module__KsnsyW__ol",
  "ul": "List-module__KsnsyW__ul",
});
